module.exports = __webpack_public_path__ + "static/media/bg.74be41fa.png";